import { render, staticRenderFns } from "./TrashButton.vue?vue&type=template&id=46625786&scoped=true"
import script from "./TrashButton.vue?vue&type=script&lang=js"
export * from "./TrashButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46625786",
  null
  
)

export default component.exports